import { render } from "./App.vue?vue&type=template&id=48d69d10"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=48d69d10&lang=css"

import exportComponent from "C:\\Users\\mvillegas\\Desktop\\coonfia-web\\repo-coonfia-web\\coonfia-mantenedor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__